<template lang="pug">
control
  field(:class="{ invalid: !first.meta.valid && first.meta.touched }")
    label(:for="first.id")(v-html="first.label")
    input(
      @blur="first.blur"
      v-model="first.model",
      :type="first.type",
      :name="first.id",
      :placeholder="first.placeholder",
      :id="first.id")
    error(v-if="!first.meta.valid && first.meta.touched") {{ first.errorMessage }}

  field(:class="{ invalid: !last.meta.valid && last.meta.touched }")
    label(:for="last.id")(v-html="last.label")
    input(
      @blur="last.blur"
      v-model="last.model",
      :type="last.type",
      :name="last.id",
      :placeholder="last.placeholder",
      :id="last.id")
    error(v-if="!last.meta.valid && last.meta.touched") {{ last.errorMessage }}
</template>

<script>
import { useStore } from "vuex";
import { reactive, computed } from "vue";
import { useField } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Name",
  props: {
    field: Object,
  },
  setup(p) {
    const store = useStore();
    const first = reactive(initFirst());
    const last = reactive(initLast());

    return { first, last };

    function initFirst() {
      let labelHtml = "First Name";
      if (p.field.required !== false) labelHtml = `<b>${labelHtml}</b>`;

      const id = `${p.field.id}-first`;
      const label = `${labelHtml} <span class="${
        p.field.required === false ? "not-" : ""
      }required">*</span>`;
      const type = "text";

      let rules = yup.string().trim().nullable().min(2);

      if (p.field.required !== false) rules = rules.required();

      const { value, errorMessage, meta, handleBlur, validate } = useField(
        id,
        rules,
        {
          validateOnInput: true,
          initialValue: store.getters.model[p.field.id]?.[0] || null,
        }
      );

      const model = computed({
        get: () => store.getters.model[p.field.id]?.[0] || "",
        set: (v) => {
          if (!v) value.value = null;
          else value.value = v;
          store.commit("updateModel", { id: p.field.id, index: 0, value: v });
        },
      });

      const blur = async () => {
        store.commit("pushLastFieldToDataLayer", id);
        await validate();
        handleBlur();
      };

      const placeholder = p.field.required === false ? "" : "(Required)";

      return { id, label, type, model, meta, blur, errorMessage, placeholder };
    }

    function initLast() {
      let labelHtml = "Last Name";
      if (p.field.required !== false) labelHtml = `<b>${labelHtml}</b>`;

      const id = `${p.field.id}-last`;
      const label = `${labelHtml} <span class="${
        p.field.required === false ? "not-" : ""
      }required">*</span>`;
      const type = "text";

      let rules = yup.string().trim().nullable().min(2);

      if (p.field.required !== false) rules = rules.required();

      const { value, errorMessage, meta, handleBlur, validate } = useField(
        id,
        rules,
        {
          validateOnInput: true,
          initialValue: store.getters.model[p.field.id]?.[1] || null,
        }
      );

      const model = computed({
        get: () => store.getters.model[p.field.id]?.[1] || "",
        set: (v) => {
          if (!v) value.value = null;
          else value.value = v;
          store.commit("updateModel", { id: p.field.id, index: 1, value: v });
        },
      });

      const blur = async () => {
        store.commit("pushLastFieldToDataLayer", id);
        await validate();
        handleBlur();
      };

      const placeholder = p.field.required === false ? "" : "(Required)";

      return { id, label, type, model, meta, blur, errorMessage, placeholder };
    }
  },
};
</script>

<style lang="scss" scoped></style>
